import './ProgressBar.css';
import { ReactNode } from 'react';

type ProgressBarProps = { children?: ReactNode; progress: number };
export const ProgressBar = ({ children, progress }: ProgressBarProps): JSX.Element => {
	return (
		<progress-bar>
			<div className="message">
				<span>{children}</span>
			</div>
			<div className="progress" style={{ width: `${progress}%` }} />
			<div className="progress-blend" />
		</progress-bar>
	);
};
